import React, { useEffect } from "react";
import HeroSection from "../components/HeroSection/HeroSection";

const Home = () => {
  useEffect(() => {
    // Définir le titre de la page d'accueil
    document.title = "AMSEBRID - Location de voitures à Bejaia";
  }, []);

  return (
    <div>
      <HeroSection />
    </div>
  );
};

export default Home;
